import { useEffect, useRef, useState } from "react";
import profileAvatar from "../../../assets/img/profile-avatar-gray.jpg";
import Card from "../../../components/Card/Card";
import List from "../../../components/List/List";
import Pagination from "../../../components/Pagination/Pagination";
import { useAuth } from "../../../contexts/auth";
import CondominioService from "../../../services/CondominioService";
import "./ListCondominios.css";
import { Tag } from "../../../components/Tag/Tag";
import { BsCpu } from "react-icons/bs";
import { UnitsFlow } from "../../../components/UnitsFlow/UnitsFlow";
import { ReactFlowProvider } from "@xyflow/react";
import { useSSEContext } from "../../../contexts/sse";
import { wait } from "../../../utils/timer";

const ListCondominios = (props) => {
	const [condominio, setCondominio] = useState([]);
	const [maxPage, setMaxPage] = useState(1);
	const [currentPage, setCurrentPage] = useState(1);
	const { user, can } = useAuth();
	const [collumnClicked, setCollumnClicked] = useState({
		collumnTitle: "level",
		orderDirection: "ASC",
	});
	const { sseReceived } = useSSEContext();
	const [isLoading, setIsLoading] = useState(true);
	const cancelTokenRef = useRef(null);

	const canEdit = can?.("bravas.identity.unit.update");

	const getCondominios = async (page, searchText, clientID, collumnClicked, itemsPerPage = 20) => {
		if (cancelTokenRef.current) {
			cancelTokenRef.current.abort();
		}
		cancelTokenRef.current = new AbortController();
		setIsLoading(true);
		const condominiumsResponse =
			await CondominioService.listClientCondominiosPaginated(
				page,
				searchText,
				clientID,
				collumnClicked,
				false,
				itemsPerPage,
			);
		setIsLoading(false);
		setCondominio([...condominiumsResponse.data.items]);
		setMaxPage(condominiumsResponse.data.pagination.totalPages);
	};

	useEffect(() => {
		if (!sseReceived) return;
		if (
			['unitCreated', 'unitDeleted'].includes(sseReceived.action) &&
			user?.userData?.selectedOrganization?.externalId === sseReceived.content.organization.externalId
		) {
			getCondominios(1, props.filters, user.userData.selectedOrganizationId, collumnClicked, 50);
		}
	}, [sseReceived]);

	useEffect(() => {
		getCondominios(currentPage, props.filters, user.userData.selectedOrganizationId, collumnClicked, 50);
	}, [user, props.filters, collumnClicked, props.refreshKey, currentPage]);

	return (
		<>
			<div className="list-container list-visibility">
				{props.viewMode === "list" ? (
					<List
						isLoading={isLoading}
						selectableRows={canEdit}
						handleCollumnTitleClick={(collumnIndex) =>
							setCollumnClicked(collumnIndex)
						}
						collumsObjIndex={[
							{
								collumnLabel: "Nome",
								index: "name",
								type: "text",
								custom: ({ row }) => (
									<p className="list-unit-name-collumn">
										{row.name}
										{row.licenses && row.licenses.length > 0 && (
											<span className="list-licenses-icon">
												<BsCpu />
											</span>
										)}
									</p>
								)
							},
							{
								collumnLabel: "Etiquetas",
								index: "tags",
								type: "text",
								custom: ({ row }) => (
									<>
										{row.tags && row.tags.length > 0 ? (
											<div style={{ display: 'flex', gap: '4px' }}>
												{row.tags?.map(tag => <Tag key={tag.id} tag={tag} />)}
											</div>
										) : (
											<span style={{ opacity: 0.4 }}>Nenhuma</span>
										)}
									</>
								)
							},
							{ collumnLabel: "Sub-organização", index: "isSubOrganization", type: "boolean-text" },
							{ collumnLabel: "Cidade", index: "address.city", type: "text" },
							{
								collumnLabel: "Pertence a",
								index: "parent",
								type: "text",
								custom: ({ row }) => row.parent?.name ?? 'Principal'
							},
						]}
						data={condominio}
					/>
				) : (
					<div style={{ width: "100%", height: "calc(100vh - 200px)" }}>
						<ReactFlowProvider>
							<UnitsFlow units={condominio} />
						</ReactFlowProvider>
					</div>
				)}
			</div>
			<div className="card-visibility">
				{condominio &&
					condominio.map((condominio, index) => (
						<Card
							key={index}
							data={condominio}
							image={profileAvatar}
							delete={() => CondominioService.deleteCondominio(condominio.id)}
							navigateOnDelete={"../consulta-condominios"}
							navigateOnEdit={"../cadastro-condominios"}
							askForPasswordOnDelete={true}
						>
							<p className="card-content-title">{condominio.name_local}</p>
							<p className="card-content">Cidade: {condominio.city}</p>
							<p className="card-content">
								Responsável: {condominio.responsable}
							</p>
							<p className="card-content">
								Contato: {condominio.contact_responsable}
							</p>
						</Card>
					))}
			</div>
			<Pagination
				rowsPerPage={50}
				maxPage={maxPage}
				changePage={(page) =>
					setCurrentPage(page)
				}
			/>
		</>
	);
};

export default ListCondominios;
